import { defineEffect } from '../../../core/effect';
import { attackSpec } from '../fx/attack';

/** 攻撃宣言（モンスターに攻撃）（Issue #589。状況は共通側の `editorPorts/duelSituations/attack.js` が決め、絵の組み立ては `../fx/attack.js`） */
export default defineEffect({ situation: 'attack_monster', role: 'effect', ...attackSpec(false) }, 'attack_monster_effect.js');
